<div class="handlebar-container" [ngClass]="rootClassName" (click)="onAction($event)">
  <img loading="lazy" src="/assets/images/handlebar.png" alt="handlebar" class="handlebar draggable"/>
</div>
